/* esm.sh - applesauce-common@5.2.0/dist/operations/comment */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/comment.mjs";
